//axios api
import officeApi from "@/lib/OfficeApi";
import connectConfig from "@/config/connectConfig";

export const getAllLandingPage = async () => {
  try {
    const queryRoute = `/landing/getAllLandingPage`;

    const fetchRes = officeApi.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const createOrEditLandingPage = async (id, data) => {
  try {
    const queryRoute = `/landing/createOrEditLandingPage`;

    const reqBody = {
      id: id === undefined ? 0 : id,
      data: data,
    };

    const fetchRes = officeApi.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const insertLandingImagesById = async (id, key) => {
  try {
    const queryRoute = `/landing/insertLandingImagesById/${id}`;

    const reqBody = {
      key: key,
    };

    const fetchRes = officeApi.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const deleteLandingImagesById = async (landing_master_id, imageId) => {
  try {
    const queryRoute = `/landing/deleteLandingImagesById/${landing_master_id}`;

    const reqBody = {
      imageId: imageId,
    };

    const fetchRes = officeApi.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const hiddenLandingImagesById = async (imaegsId, hidden) => {
  try {
    const queryRoute = `/landing/hiddenLandingImagesById/${imaegsId}`;

    const reqBody = {
      hidden: hidden,
    };

    const fetchRes = officeApi.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const floatLandingImagesById = async (imaegsId, float) => {
  try {
    const queryRoute = `/landing/floatLandingImagesById/${imaegsId}`;

    const reqBody = {
      float: float,
    };

    const fetchRes = officeApi.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getLandingDetailsById = async (id) => {
  try {
    const queryRoute = `/landing/getLandingDetailsById/${id}`;

    const fetchRes = officeApi.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const landingReorder = async (id, data) => {
  try {
    const queryRoute = `/landing/landingReorder/${id}`;

    const reqBody = {
      data: data,
    };

    const fetchRes = officeApi.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const uploadImages = async (params) => {
  try {
    const queryRoute = `/landing/uploadImages/`;

    const fetchRes = await fetch(
      `${connectConfig.backendURLOffice}${queryRoute}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...params,
        }),
      }
    );

    return await fetchRes.json();
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const cloneLanding = async (id) => {
  try {
    const queryRoute = `/landing/clone/${id}`;

    const fetchRes = officeApi.axios.post(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const deleteImages = async (params) => {
  try {
    const queryRoute = `/landing/deleteImages/`;

    const fetchRes = await fetch(
      `${connectConfig.backendURLOffice}${queryRoute}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...params,
        }),
      }
    );

    return await fetchRes.json();
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
